import { trackEvent } from '@/angulartics.matomo/analytics-services';
import { usePublicSettings } from '@/react/portainer/settings/queries';
import { FeatureFlag } from '@/react/portainer/feature-flags/useFeatureFlag';

export function useAnalytics() {
  const telemetryQuery = usePublicSettings({
    select: (settings) => ({
      EnableTelemetry: settings.EnableTelemetry,
      Features: settings.Features,
    }),
  });

  return { trackEvent: handleTrackEvent };

  function handleTrackEvent(...args: Parameters<typeof trackEvent>) {
    if (
      telemetryQuery.data?.EnableTelemetry &&
      !telemetryQuery.data.Features[FeatureFlag.DISABLE_EXTERNAL_REQUESTS]
    ) {
      trackEvent(...args);
    }
  }
}
